/* import __COLOCATED_TEMPLATE__ from './lsg-icon-play-video.hbs'; */
import Component from '@ember/component';

/**
 * @type {Object}   The potential fill types for the play icons.
 */
export const LSG_ICON_PLAY_VIDEO__FILL_TYPE = {
  WHITE: 'white',
  NONE: 'none',
};

/**
 * This is the play video icon that would show up on most Glimmer media that is able to show a video.
 */
export default Component.extend({
  /**
   * Component props
   */
  tagName: 'span',
  classNames: ['LSG-c-lsg-icon-play-video'],

  /**
   * This is the inner background of the play icon.
   *
   * @type {String}   of type LSG_ICON_PLAY_VIDEO__FILL_TYPE.*
   */
  fillType: LSG_ICON_PLAY_VIDEO__FILL_TYPE.WHITE
});
